import HouveSustentacaoOral from '@mui/icons-material/HowToReg';
import { Tooltip } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ReactComponent from './ReactComponent';

class SustentacaoOralAnterior extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            pedido: computed,
            sustentacoesAnteriores: computed,
            dataUltimaSustentacaoAnterior: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get pedido() {
        return this.observableProps.pedido;
    }

    get sustentacoesAnteriores() {
        return this.registro.detalhes && this.registro.detalhes.sustentacoesAnteriores
            ? this.registro.detalhes.sustentacoesAnteriores
            : [];
    }

    get dataUltimaSustentacaoAnterior() {
        for (let sustentacao of this.sustentacoesAnteriores) {
            if (this.pedido.nomeDaParte === sustentacao.nomeParte) {
                return moment(sustentacao.dtaJulgamento, 'DD-MM-YYYY').format('DD/MM/YYYY');
            }
        }
        return null;
    }

    render() {
        return (
            this.dataUltimaSustentacaoAnterior && (
                <Tooltip
                    title={
                        'Houve inscrição de advogado para esta parte, nessa fase processual, na sessão de julgamento do dia ' +
                        this.dataUltimaSustentacaoAnterior +
                        '. VERIFICAR SE EFETIVAMENTE A SUSTENTAÇÃO ORAL OCORREU NESTA DATA.'
                    }
                >
                    <HouveSustentacaoOral style={{ fill: 'darkorange' }} />
                </Tooltip>
            )
        );
    }
}

export default inject('stores')(observer(SustentacaoOralAnterior));
